import { connect } from 'react-redux';
import { getApp } from '../App';
import Fullscreen from '../components/fullscreenControl/Fullscreen';

const mapStateToProps = state => ({
  isFullscreen: state.layout.isFullscreen,
  isMobile: state.layout.isMobile,
  hideFullscreenButton: state.layout.hideFullscreenButton,
});

const mapDispatchToProps = () => ({
  setFullscreen: fullscreen => getApp().ui.setFullscreen(fullscreen),
});

const FullscreenControls = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Fullscreen);

export default FullscreenControls;
